/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type {
  OracleSeriesRandomMock,
  OracleSeriesRandomMockInterface,
} from "../OracleSeriesRandomMock";

const _abi = [
  {
    inputs: [],
    name: "OracleWrongInput",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "max",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "seed",
        type: "uint256",
      },
    ],
    name: "getRandomNumber",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "max",
        type: "uint256",
      },
      {
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
    ],
    name: "setRandoms",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

export class OracleSeriesRandomMock__factory {
  static readonly abi = _abi;
  static createInterface(): OracleSeriesRandomMockInterface {
    return new Interface(_abi) as OracleSeriesRandomMockInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): OracleSeriesRandomMock {
    return new Contract(
      address,
      _abi,
      runner
    ) as unknown as OracleSeriesRandomMock;
  }
}
